import React, { useMemo } from 'react';
import { GtmProduct } from '../../../types/go-to-market';
import { Product } from '../../../types/product';
import { LIST_HEADING_STYLES } from './ArchitectureDetailStyles';
import ArchitectureProductCard from './ArchitectureProductCard';


const ArchitectureProductList: React.FC<{
  products: Map<Product['id'], GtmProduct>,
  productsLoading: boolean,
  hoveredProducts: Set<GtmProduct['id']>,
  pinnedProducts: Set<GtmProduct['id']> | null,
}> = ({
  products,
  productsLoading,
  hoveredProducts,
  pinnedProducts = null,
}) => {
  const listItems = useMemo(() => {
    return Array.from(products.values());
  }, [products]);

  return (
    <div className="flex flex-col gap-4 w-full flex-1">
      <h3 className={`${LIST_HEADING_STYLES} mb-0`}>Product Portfolio</h3>
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 cust-large:grid-cols-3 gap-4 w-full">
        {!productsLoading
          ? (
              listItems.length > 0
                ? listItems.map((product, idx) => (
                    <ArchitectureProductCard
                      key={product.id}
                      product={product}
                      hoveredComponent={hoveredProducts.has(product.id)}
                      pinnedComponent={pinnedProducts?.has(product.id) || false}
                    />
                  ))
                : (
                    <div className="col-span-full italic text-gray-50">No products found for this architecture.</div>
                  )
              
            )
          : (
              <div className="col-span-full italic text-gray-50">Loading...</div>
            )
        }
      </div>
    </div>
  );
}

export default ArchitectureProductList;